<form *ngIf="twoFactorForm" [formGroup]="twoFactorForm" (ngSubmit)="onSubmit(twoFactorForm)">
  <div fxLayout="row" fxLayoutAlign="center center" class="card">
    <mat-card>
      <mat-card-header>
        <mat-card-title class="mat-h2">Please enter the code from your authentication app</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="full-width" style="text-align: center">{{ username }}</div>
        <mat-form-field class="full-width">
          <input matInput type="text" placeholder="Authentication code" formControlName="totp" required autofocus
                 [cdkTrapFocusAutoCapture]="!loading" [cdkTrapFocus]="!loading">
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-raised-button type="submit" color="primary" [class.spinner]="loading"
                [disabled]="loading || !twoFactorForm.valid">Login
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</form>
